import eventBus from '@/utils/event-bus';

export default {
    props: {
        initialData: {
            type: Object,
            default: () => {}
        },
        optionsId: {
            type: String,
            default: ''
        }
    },
    created() {
        this.setInitialData();
    },
    mounted() {
        this.addListeners()
    },
    watch: {
        initialData: {
            handler(newVal, oldVal) {
                const updateValues = ['gasPrice', 'gasConsumption']
                for(const key in newVal) {
                    if(updateValues.includes(key) && newVal[key] !== oldVal[key]) {
                        this.data[key] = newVal[key] 
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        addListeners() {
            eventBus.$on('settingsUpdated', this.settingsUpdatedHandler)
        },
        settingsUpdatedHandler() {
            this.$set(this, 'data', this.initialData);
        },
        fieldChangeHandler(output, dataKey) {
            this.data[dataKey] = output;
            this.emitChange(this.data);
        },
        setInitialData() {
            this.data = this.initialData;
        },
        emitChange(data) {
            this.$emit('change', data);
        }
    }
  }